(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TwCitySelector", [], factory);
	else if(typeof exports === 'object')
		exports["TwCitySelector"] = factory();
	else
		root["TwCitySelector"] = factory();
})(window, function() {
return 